<template>
    <div class="head">
        <div class="mid-width nav-wrapper clearfix">
            <div class="logo">
                 <a href="/"><img src="./logo.png" width="100%" height="100%"></a>
            </div>
            <div class="nav-bar clearfix">
                <router-link to="/" tag="a" class="nav-item">首页</router-link>
                <router-link to="/service" tag="a" class="nav-item business">
                    业务范围
                    <div class="business-content">
                        <router-link to="/service1" tag="a">诉讼业务</router-link>
                        <router-link to="/service2" tag="a">非诉业务</router-link>
                    </div>
                </router-link>
                <router-link to="/team" tag="a" class="nav-item">专业人员</router-link>
                <router-link to="/successCase" tag="a" class="nav-item">典型案例</router-link>
                <router-link to="/news" tag="a" class="nav-item">新闻资讯</router-link>
                <router-link to="/successCase" tag="a" class="nav-item">法律讲堂</router-link>
                <!--<a class="nav-item" href="tencent://message/?uin=407454071&Site=qq&Menu=yes" target="_blank">在线咨询</a>-->
                <router-link to="/about" tag="a" class="nav-item contact">
                    联系我们
                    <div class="contact-content">
                        <router-link to="/about" tag="a">联系方式</router-link>
                        <router-link to="/join" tag="a">加入我们</router-link>
                    </div>
                </router-link>                
            </div>
            <div class="phone-wrapper">186-2195-1461</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            link: 'http://www.baidu.com'
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/common/css/common';

.head {
    height: 70px;
    font-size: 15px;
    //border-bottom: 1px solid rgb(242, 242, 242);
    box-shadow: 1px 1px 1px rgba(201, 201, 201, 0.349019607843137);
    .nav-wrapper {
        padding-top: 16px;
        height: 70px;
        line-height: 40px;
        .logo {
            float: left;
            width: 144px;
            height: 40px;
            //background: url('./logo.png') no-repeat;
        }
        .nav-bar {
            float: left;
            width: 912px;
            font-size: 0;
            text-align: right;
            .business-content {
                display: none;
                position: absolute;
                background-color: #f9f9f9;
                min-width: 60px;
                box-shadow: 0px 8px 8px 0px rgba(0,0,0,0.2);
            } 
            .business-content a {
                color: black;
                padding: 2px 10px;
                text-decoration: none;
                display: block;
            }
            .business-content a:hover {background-color: #f1f1f1}
            .business:hover .business-content {
                display: block;
                z-index: 1000;
            }

            .contact-content {
                display: none;
                position: absolute;
                background-color: #f9f9f9;
                min-width: 60px;
                box-shadow: 0px 8px 8px 0px rgba(0,0,0,0.2);
            } 
            .contact-content a {
                color: black;
                padding: 2px 10px;
                text-decoration: none;
                display: block;
            }
            .contact-content a:hover {background-color: #f1f1f1}
            .contact:hover .contact-content {
                display: block;
                z-index: 1000;
            }

            .nav-item {
                display: inline-block;
                color: #666;
                margin-right: 60px;
                font-size: 15px;
                &:hover {
                    color: #20A0FE;
                }
                &.router-link-exact-active {
                    font-weight: bold;
                    color: #20A0FE;
                    //border-bottom: solid 2px #20A0FE;
                }
                 
            }
        }
        .phone-wrapper {
            float: right;
            width: 144px;
            height: 40px;
            padding-left: 32px;
            background: url('./icon-phone.png') no-repeat 12px 11px rgb(32, 160, 254);
            color: #fff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mheader/mheader.vue